import { CommonModule } from "@angular/common";
import { Component, Input, ViewEncapsulation } from "@angular/core";
import { IonicModule } from "@ionic/angular";
import { TranslocoModule } from "@ngneat/transloco";
import { combineLatest } from "rxjs";
import { map } from "rxjs/operators";
import { IdleService } from "../../../configuration/services/idle.service";
import { LocationStateQuery } from "../../../configuration/state/location-state.query";
import { LocationStateService } from "../../../configuration/state/location-state.service";
import { CriticalResultsUiState } from "../services/critical-results-ui.state";
import { OpenLocationGuardService } from "../services/open-location-guard.service";

@Component({
	selector: "app-open-location-button",
	templateUrl: "./open-location-button.component.html",
	styleUrls: ["./open-location-button.component.scss"],
	encapsulation: ViewEncapsulation.None,
	standalone: true,
	imports: [CommonModule, IonicModule, TranslocoModule],
})
export class OpenLocationButtonComponent {
	@Input() v2 = false;
	@Input() tonal = false;

	constructor(
		private locationStateService: LocationStateService,
		private openLocationGuardService: OpenLocationGuardService,
		private locationStateQuery: LocationStateQuery,
		private idleService: IdleService,
		private criticalResultsUiState: CriticalResultsUiState,
	) {}

	private openingLocation = false;

	canOpen$ = combineLatest([
		this.locationStateQuery.isClearedForOperation$,
		this.locationStateQuery.mandatoryPositionsWithoutAttendant$,
		this.locationStateQuery.selectState$,
		this.idleService.isInactive$,
		this.criticalResultsUiState.loading$,
		this.criticalResultsUiState.error$,
	]).pipe(
		map(
			([isCleared, missingPositions, state, isInactive, criticalResultsLoading, criticalResultsError]) =>
				isCleared === true &&
				missingPositions.length === 0 &&
				state === "Closed" &&
				isInactive === false &&
				criticalResultsLoading === false &&
				criticalResultsError === false,
		),
	);

	openLocation = async () => {
		if (this.openingLocation || (this.v2 && (await this.canOpen$.firstAsync()) !== true)) {
			return;
		}

		this.openingLocation = true;
		try {
			if (await this.openLocationGuardService.allowOpeningLocation()) {
				await this.locationStateService.openLocation();
			}
		} finally {
			this.openingLocation = false;
		}
	};
}
